import { useState, useCallback, useRef, useEffect } from 'react';
import _debounce from 'lodash/debounce';


const MOUSE_OVER = 'mouseover';
const MOUSE_OUT = 'mouseout';

const useHover = () => {
  const isMounted = useRef(true);
  useEffect(() => () => { isMounted.current = false; }, []);
  const [isHovered, setIsHovered] = useState(false);
  const debouncedSetIsHovered = useCallback(
    _debounce(nextValue => isMounted.current && setIsHovered(nextValue), 50),
    [],
  );
  const handleMouseOver = useCallback(() => debouncedSetIsHovered(true), []);
  const handleMouseOut = useCallback(() => debouncedSetIsHovered(false), []);
  const ref = useRef<HTMLElement>();
  const callbackRef = useCallback(
    (node) => {
      if (ref.current) {
        ref.current.removeEventListener(MOUSE_OVER, handleMouseOver);
        ref.current.removeEventListener(MOUSE_OUT, handleMouseOut);
      }
      ref.current = node;
      if (ref.current) {
        ref.current.addEventListener(MOUSE_OVER, handleMouseOver);
        ref.current.addEventListener(MOUSE_OUT, handleMouseOut);
      }
    },
    [handleMouseOver, handleMouseOut]
  );
  return [callbackRef, isHovered];
};

export default useHover;